<div class="container card p-3 mt-3" *ngIf="!isLoading && special">
  <h2 class="mb-3 text-primary">Special Day Details</h2>
  <table class="table table-bordered">
    <tbody>
    <tr>
      <th width="30%">Date</th>
      <td>{{ special.date.toDate() | date:'dd MMM yyyy' }}</td>
    </tr>
    <tr>
      <th>Teacher Name</th>
      <td>{{ special.teacherName }}</td>
    </tr>
    <tr>
      <th>Centre</th>
      <td>{{ special.centreName }}</td>
    </tr>
    <tr>
      <th>Special Day</th>
      <td>{{ special.specialDay }}</td>
    </tr>

    <tr>
      <th>File URLs</th>
      <td>
        <ul class="files-vertical" *ngIf="special.fileUrls && special.fileUrls.length; else noFiles">
          <li *ngFor="let file of special.fileUrls; let last = last">
            <a [href]="file" target="_blank">{{ extractFileName(file) }}</a>{{ last ? '' : ',' }}
          </li>
        </ul>
        <ng-template #noFiles>No files uploaded</ng-template>
      </td>
    </tr>

    </tbody>
  </table>
  <div class="row justify-content-center d-flex mt-3">
    <div class="col-md-4">
      <button mat-raised-button color="warn" routerLink="/home/education/special-day-list">
        Back to List
      </button>
    </div>
  </div>
</div>
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
